import { render } from "./CourseCard.vue?vue&type=template&id=59c39737&scoped=true"
import script from "./CourseCard.vue?vue&type=script&lang=js"
export * from "./CourseCard.vue?vue&type=script&lang=js"

import "./CourseCard.vue?vue&type=style&index=0&id=59c39737&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c39737"]])

export default __exports__